import { GoogleAnalytics } from "../../googleAnalytics";
import settings from "./_settings";

const exportButtonClick = () => {
    GoogleAnalytics.reportEvent({ 
        name: `${settings.scope}:${settings.categoryName}:click`, 
        category: settings.categoryName 
    });
};

export default exportButtonClick;